export default __webpack_public_path__ + "static/media/logo1.96781faa.png";